import { useEffect, useState } from 'react';
import { useAppSelector } from '../../store/hooks';
import {
  soldProductsByCustomerFiltersSelector,
  soldProductsByCustomerRangesSelector,
} from '../../store/selectors/reportsSelectors';
import { RangeTableFiltersType } from '../../core/types/coreTypes';

export const useSoldProductsByCustomerRanges = () => {
  const filters = useAppSelector(soldProductsByCustomerFiltersSelector);
  const { quantity, costNet, salesNet } = useAppSelector(soldProductsByCustomerRangesSelector);

  const [rangePatterns, setRangePatterns] = useState({
    quantity: { min: quantity.min, max: quantity.max },
    costNet: { min: costNet.min, max: costNet.max },
    salesNet: { min: salesNet.min, max: salesNet.max },
  });

  const [range, setRange] = useState<RangeTableFiltersType>({
    quantity: filters.quantity
      ? [filters.quantity.min.toString(), filters.quantity.max.toString()]
      : [rangePatterns.quantity.min.toString(), rangePatterns.quantity.max.toString()],
    costNet: filters.costNet
      ? [filters.costNet.min.toString(), filters.costNet.max.toString()]
      : [rangePatterns.costNet.min.toString(), rangePatterns.costNet.max.toString()],
    salesNet: filters.salesNet
      ? [filters.salesNet.min.toString(), filters.salesNet.max.toString()]
      : [rangePatterns.salesNet.min.toString(), rangePatterns.salesNet.max.toString()],
  });

  useEffect(() => {
    setRangePatterns((prevState) => ({ ...prevState, quantity: { min: quantity.min, max: quantity.max } }));
    setRange((prevState) => ({ ...prevState, quantity: [quantity.min.toString(), quantity.max.toString()] }));
  }, [quantity.min, quantity.max]);

  useEffect(() => {
    setRangePatterns((prevState) => ({ ...prevState, costNet: { min: costNet.min, max: costNet.max } }));
    setRange((prevState) => ({ ...prevState, costNet: [costNet.min.toString(), costNet.max.toString()] }));
  }, [costNet.min, costNet.max]);

  useEffect(() => {
    setRangePatterns((prevState) => ({ ...prevState, salesNet: { min: salesNet.min, max: salesNet.max } }));
    setRange((prevState) => ({ ...prevState, salesNet: [salesNet.min.toString(), salesNet.max.toString()] }));
  }, [salesNet.min, salesNet.max]);

  useEffect(() => {
    if (!filters?.quantity) {
      setRange((prevState) => ({ ...prevState, quantity: [quantity.min.toString(), quantity.max.toString()] }));
    }
    if (!filters?.costNet) {
      setRange((prevState) => ({ ...prevState, costNet: [costNet.min.toString(), costNet.max.toString()] }));
    }
    if (!filters?.salesNet) {
      setRange((prevState) => ({ ...prevState, salesNet: [salesNet.min.toString(), salesNet.max.toString()] }));
    }
    // eslint-disable-next-line
  }, [filters.quantity, filters.salesNet, filters.costNet]);

  return { range, setRange, rangePatterns };
};
